import { createFileRoute } from '@tanstack/react-router'

import { MetadataPage } from '@/pages/metadata/Metadata.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata/',
)({
  component: MetadataPage,
  loader: () => ({ breadcrumbTitle: 'Workitem Metadata' }),
})
